"use strict";

exports.__esModule = true;

var unfetch_1 = require("unfetch");

var videoplayer_utils_1 = require("@svt/videoplayer-utils");

var VIDEO_API_BASE_URL = 'https://api.svt.se/videoplayer-api/video';
var VIDEO_API_COLLAB_BASE_URL = 'https://api.svt.se/video';
var CURRENT_TIME_API_URL = 'https://current-time.app.svt.se';
exports.NUMBER_OF_RETRIES = 3;

var isStringOnlyDigits = function isStringOnlyDigits(str) {
  return /^\d+$/.test(str);
}; // SvtId: 8qWvDZ2
// Pevid: 1366586-003A
// ArticleId clip: 20881892
// Channel: ch-svt1


var isSvtId = function isSvtId(id) {
  return typeof id === 'string' && id.match(/^[0-9]+$/) === null && // is not articleId
  id.indexOf('-') === -1; // Is not pevid or channel
};

var parseStringAsProgramVersionIdOrClipId = function parseStringAsProgramVersionIdOrClipId(str) {
  return isStringOnlyDigits(str) ? parseInt(str, 10) : str;
};
/**
 * A API fetch wrapper with that will retry (recursively) a failing request x number of times.
 *
 * @param {VideoId} id The video ID
 * @param {number} retries Number of retries left
 * @returns {Promise<APIResponse>} A promise of the API response
 */


var fetchWithRetries = function fetchWithRetries(id, retries) {
  if (retries === void 0) {
    retries = exports.NUMBER_OF_RETRIES;
  }

  var retriesLeft = retries - 1;
  var apiUrl = isSvtId(id) ? VIDEO_API_COLLAB_BASE_URL : VIDEO_API_BASE_URL;
  return unfetch_1["default"](apiUrl + "/" + id).then(function (response) {
    if (!response.ok) {
      throw new Error(response.statusText);
    }

    return response.json();
  })["catch"](function (error) {
    if (retriesLeft <= 0) {
      throw error;
    }

    return fetchWithRetries(id, retriesLeft);
  });
};
/**
 * Fetch stream info from API. Retries a failed request three times before rejecting.
 *
 * @param {VideoId} id The video ID. Expected to be a vision ID if it's an episode or Escenic ID if it's a clip.
 * @returns {Promise<StreamInfo>} A Promise of the stream info object
 */


exports.fetchStreamInfo = function (id) {
  return fetchWithRetries(id, exports.NUMBER_OF_RETRIES).then(function (json) {
    // Convert videoReferences from array to object map.
    var videoReferences = json.videoReferences.reduce(function (references, reference) {
      references[reference.format] = reference.url;
      return references;
    }, {});
    var programVersionId = json.programVersionId,
        svtId = json.svtId,
        programTitle = json.programTitle,
        episodeTitle = json.episodeTitle,
        mmsStatistics = json.mmsStatistics,
        contentDuration = json.contentDuration,
        liveNow = json.live,
        liveStartTimeUTC = json.liveStartTimeUTC,
        secondsToLiveRetry = json.secondsToLiveRetry; // Use SvtId if available, or fallback to ProgramVersionId or ClipId

    var videoId = svtId || parseStringAsProgramVersionIdOrClipId(programVersionId);
    var liveStart = liveStartTimeUTC ? new Date(liveStartTimeUTC * 1000).toISOString() : null;
    return {
      videoId: videoId,
      videoReferences: videoReferences,
      programTitle: programTitle,
      episodeTitle: episodeTitle,
      liveNow: liveNow,
      liveStart: liveStart,
      secondsToLiveRetry: typeof secondsToLiveRetry === 'number' ? secondsToLiveRetry : null,
      duration: contentDuration,
      comscore: videoplayer_utils_1.pick(mmsStatistics, 'mms_tid', 'ns_st_pl', 'ns_st_pr', 'ns_st_ep', 'ns_st_cl', 'ns_st_li', 'svt_taggar', 'svt_contenttype')
    };
  });
};

exports.fetchCurrentTime = function () {
  return unfetch_1["default"](CURRENT_TIME_API_URL).then(function (response) {
    if (!response.ok) {
      throw new Error(response.statusText);
    }

    return response.json();
  }).then(function (_a) {
    var currentTime = _a.currentTime;
    return currentTime;
  });
};